<template lang="pug">
  div(:class="{ bgblack: introBG}")
    transition(name="slideUp")
      .welcome(v-if='intro' aria-label="Welcome Screen, press enter key to enter the site.")
        transition(name="fade")
          .intro(v-if='!loading')
            .screen
              img.cover(:src="introImage")
            .logo
              img(src="static/logos/caam_logo_white.svg" alt="Image of Caam Logo which spells CAAM.")
            button.next(@click='enter' role="Button" aria-label="Click or press enter to enter the site.")
              img(src="static/icons/arrow_down_white.svg" alt="Downfacing Triangle")
    transition(name="slideUpOffset")
      .main(v-if='!intro')
        top-nav(headerColor = "black")
        transition(name="fade")
          .home(v-if='!loading')
            home-exhibition(:exhibition="exhibitionFirst" key="first")
            div(v-if="!introBG")
              home-exhibition(v-for="exhibition in exhibitions" :exhibition="exhibition" :key="title(exhibition)")
              home-events(:programs="programs" v-if="programs.length > 0")
              home-explore(:explore="explore")
        bottom-nav(footerColor="black" v-if="!introBG")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import HomeEvents from '@/components/home/HomeEvents'
import HomeExplore from '@/components/home/HomeExplore'
import HomeExhibition from '@/components/home/HomeExhibition'

export default {
  name: 'home',

  mixins: [DataMixin, ComponentMixin],

  components: {
    HomeEvents,
    HomeExplore,
    HomeExhibition
  },

  data () {
    return {
      intro: window._caam_intro,
      introBG: window._caam_introBG,
      first: true,
      mainImage: {},
      ready: false,
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: true
      }
    }
  },

  created () {
    this.intro = window._caam_intro
    this.introBG = window._caam_introBG

    // Replace this
    window._caam_whiteHeader = false
    this.requestData('home', 'home')
    window.addEventListener('wheel', this.handleWheel)
    window.addEventListener('keydown', this.handleKey)

    // Set page title
    document.title = 'CAAM | California African American Museum'
  },

  destroyed () {
    window.removeEventListener('wheel', this.handleWheel)
    window.removeEventListener('keydown', this.handleKey)
  },

  methods: {
    enter: function () {
      window._caam_intro = false
      this.intro = window._caam_intro

      setTimeout(() => {
        window._caam_introBG = false
        this.introBG = window._caam_introBG
      }, 1020)
    },

    handleWheel (e) {
      if (this.introBG) {
        // e.preventDefault()
      }
      if (this.first && this.intro) {
        let debounce = true
        if (e.deltaY > 0 && debounce) {
          this.enter()
          debounce = false
        }
      }
    },

    handleKey (e) {
      if (this.introBG) {
        // e.preventDefault()
      }
      if (this.first && this.intro) {
        let debounce = true
        if (e.keyCode === 40 && debounce) {
          this.enter()
          debounce = false
        }
        if (e.keyCode === 13 && debounce) {
          this.enter()
          debounce = false
        }
      }
    },

    title: function (exhibition) {
      return exhibition.content.title
    }
  },

  computed: {
    exhibitionFirst: function () {
      const first = this.loadedData.home.exhibitions.splice(0, 1)
      return first[0]
    },

    exhibitions: function () {
      return this.loadedData.home.exhibitions
    },

    programs: function () {
      return this.loadedData.home.programs
    },

    introImage: function () {
      return this.loadedData.home.intro.mainImage
    },

    explore: function () {
      return this.loadedData.home.intro.content.explore
    },

    key: function () {
      return 'home'
    }
  },

  watch: {
    $route: function () {
      // this.intro = this.$ls.get('intro')
      // this.introBG = this.$ls.get('introBG')
      this.intro = window._caam_intro
      this.introBG = window._caam_introBG
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  .home
    @include respond-to(xs)
      padding-top: 5rem
    > .screen
      margin-top: 19.5rem
      height: calc(100vh - 19.5rem)
      img
        object-position: 50% 25%
      @include respond-to(xs)
        margin-top: 4.5rem
  .bgblack
    background-color: #000
  .screen
    height: 100vH
    @include respond-to(xs)
      height: 70vW !important
  .welcome
    position: relative
    .logo
      position: absolute
      top: 50%
      left: 4vW
      @include translateY(-50%)
      width: 92vW
      .img
        width: 100%
    .next
      z-index: 10000
      position: absolute
      bottom: 3.8vH
      left: 46.08vW
      cursor: pointer
      width: 3.92vW
      img
        width: 100%
  .events, .explore
    margin-top: 8.8rem
    @include respond-to(xs)
      margin-top: 4rem
  .explore
    @include respond-to(xs)
      margin-bottom: 4rem
</style>



// WEBPACK FOOTER //
// Home.vue?bb51d7d6